export const libri = [
  {
    id: 1,
    titolo: "All your perfects",
    autore: "Colleen Hoover",
    categoria: "Romanzi",
    copertina: "/Romanzi/All your perfects.png",
    numero: 1,
  },
  {
    id: 2,
    titolo: "E solo Una storia d'amore",
    autore: "Anna Premoli",
    categoria: "Romanzi",
    copertina: "/Romanzi/Anna Premoli E solo una storia d'amore.png",
  },
  {
    id: 3,
    titolo: "Better",
    autore: "Carrie Leighton",
    categoria: "Romanzi",
    copertina: "/Romanzi/Better.png",
  },
  {
    id: 4,
    titolo: "Due cuori in affitto",
    autore: "Felicia Kingggsley",
    categoria: "Romanzi",
    copertina: "/Romanzi/Due cuori in affitto.png",
  },
  {
    id: 5,
    titolo: "Fabbricante di lacrime",
    autore: "Erin Soom",
    categoria: "Romanzi",
    copertina: "/Romanzi/Fabbricante di lacrime.png",
  },


 {
    id: 6,
    titolo: "Fidanzato part-time",
    autore: "Anna Zarlenga",
    categoria: "Romanzi",
    copertina: "/Romanzi/Fidanzato part-time.png",
  },


 {
    id: 7,
    titolo: "Il mio indimenticabile amore francese",
    autore: "Lucy Coleman",
    categoria: "Romanzi",
    copertina: "/Romanzi/Il mio indimenticabile amore francese.png",
  },


 {
    id: 8,
    titolo: "It Ends With us",
    autore: "Colleen Hoover",
    categoria: "Romanzi",
    copertina: "/Romanzi/It Ends With us.png",
  },


 {
    id: 9,
    titolo: "It Starts With us",
    autore: "Colleen Hoover",
    categoria: "Romanzi",
    copertina: "/Romanzi/It Starts With us.png",
  },
 {
    id: 10,
    titolo: "La verita è che non ti odio abbastanza",
    autore: "Felicia Kingsley",
    categoria: "Romanzi",
    copertina: "/Romanzi/La verita è che non ti odio abbastanza.png",
  },



 {
    id: 11,
    titolo: "Fondazione",
    autore: "Isaac Asimov",
    categoria: "Fantascienza",
    copertina: "/Romanzi/Liberi come la neve.png",
  },




 {
    id: 12,
    titolo: "Nel mondo in cui cade la neve",
    autore: "Erin Doom",
    categoria: "Romanzi",
    copertina: "/Romanzi/Nel mondo in cui cade la neve.png",
  },



 {
    id: 13,
    titolo: "Prima regola non innamorarsi",
    autore: "Felicia Kingsley",
    categoria: "Romanzi",
    copertina: "/Romanzi/Prima regola non innamorarsi.png",
  },



 {
    id: 14,
    titolo: "I segreti di una libraia",
    autore: "Michelle Gable",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/I segreti di una libraia..png",
  },

  


 {
    id: 15,
    titolo: "Il cacciatore di aquiloni",
    autore: "Khaled Hosseini",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il cacciatore di aquiloni.png",
  },




 {
    id: 16,
    titolo: "Il manosritto perduto della massonoeria",
    autore: "Jeroen Windmeiiiiijer",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il manosritto perduto della massonoeria.png",
  },


 {
    id: 17,
    titolo: "Il profondo segreto del mare",
    autore: "Fiona Valpy",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il profondo segreto del mare.png", 
  },


 {
    id: 18,
    titolo: "Il sentiero degli alberi di limone",
    autore: "Nadia Marks",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il sentiero degli alberi di limone.png",
  },




 {
    id: 19,
    titolo: "Isegreti della famiglia cartwright",
    autore: "Dinah Jefferies",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Isegreti della famiglia cartwright.png",
  },




 {
    id: 20,
    titolo: "Isegreti della famiglia cartwright",
    autore: "Dinah Jefferies",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Isegreti della famiglia cartwright.png",
  },



 {
    id: 21,
    titolo: "La bambina che guardava i treni partire",
    autore: "Ruperto Long",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/La bambina che guardava i treni partire.png",
  },





 {
    id: 22,
    titolo: "Mille splendidi soli",
    autore: "Khaled Hosseini",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Mille splendidi soli.png",
  },


 {
    id: 23,
    titolo: "Mister money",
    autore: "Vi Keeland Penelope Ward",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Mister money.png",
  },

 {
    id: 24,
    titolo: "Piccole donne",
    autore: "Louisa May Alcott",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Piccole donne.png",
  },


 {
    id: 25,
    titolo: "Ramses",
    autore: "Christian Jacq",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Ramses.png",
  },


 {
    id: 26,
    titolo: "Sia fatta la tua volontà",
    autore: "Stefano Baldi",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Sia fatta la tua volontà.png",
  },


 {
    id: 27,
    titolo: "Storia proibita di una geisha",
    autore: "Mineko asaki",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Storia proibita di una geisha.png",
  },

 {
    id: 28,
    titolo: "Storia del nuovo cognome",
    autore: "Elena Ferrante",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Storia del nuovo cognome.png",
  },

 {
    id: 29,
    titolo: "Storia di una bambina perduta",
    autore: "Elena Ferrante",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Storia di una bambina perduta.png",
  },
 {
    id: 30,
    titolo: "Storie di chi fugge e di chi resta",
    autore: "Elena Ferrante",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Storie di chi fugge e di chi resta.png",
  },


 {
    id: 31,
    titolo: "L'amica Geniale",
    autore: "Elena Ferrante",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/L'amica Geniale.png",
  },

 {
    id: 32,
    titolo: "Chi nulla rischia",
    autore: "Jeffrey Archer",
    categoria: "Gialli",
    copertina: "/Gialli/Chi nulla rischia.png",
  },


 {
    id: 33,
    titolo: "Il giallo del paese maledetto",
    autore: "Riccardo Landini",
    categoria: "Gialli",
    copertina: "/Gialli/Il giallo del paese maledetto.png",
  },


 {
    id: 34,
    titolo: "Il gioco del male",
    autore: "Angela Marsons",
    categoria: "Gialli",
    copertina: "/Gialli/Il gioco del male.png",
  },


 {
    id: 35,
    titolo: "La Confraternita degli Assassini",
    autore: "Marcello Ciccarelli & Bruno Di Marco",
    categoria: "Gialli",
    copertina: "/Gialli/La Confraternita degli Assassini.png",
  },


 {
    id: 36,
    titolo: "L'abbazia dei cento delitti",
    autore: "Marcello Simoni",
    categoria: "Gialli",
    copertina: "/Gialli/L'abbazia dei cento delitti.png",
  },


 {
    id: 37,
    titolo: "L'imbalsamatore",
    autore: "Alison Belsham",
    categoria: "Gialli",
    copertina: "/Gialli/L'imbalsamatore.png",
  },



 {
    id: 38,
    titolo: "L'uomo senza sonno",
    autore: "Antonio Lanzetta",
    categoria: "Gialli",
    copertina: "/Gialli/L'uomo senza sonno.png",
  },


 {
    id: 39,
    titolo: "Maledetta primavera.",
    autore: "Paolo Cammilli",
    categoria: "Gialli",
    copertina: "/Gialli/Maledetta primavera.png",
  },

 {
    id: 40,
    titolo: "Per la gloria di roma",
    autore: "Douglas Jackson",
    categoria: "Gialli",
    copertina: "/Gialli/Per la gloria di roma.png",
  },


 {
    id: 41,
    titolo: "Per questo mi chiamo Giovanni",
    autore: "Luigi Garlando",
    categoria: "Gialli",
    copertina: "/Gialli/Per questo mi chiamo Giovanni.png",
  },



 {
    id: 42,
    titolo: "Tre cadaveri",
    autore: "Raffaele Malavasi",
    categoria: "Giallo",
    copertina: "/Gialli/Tre cadaveri.png",
  },



 {
    id: 43,
    titolo: "Verita e bugie",
    autore: "Caroline Mitchell",
    categoria: "Gialli",
    copertina: "/Gialli/Verita e bugie.png",
  },


 {
    id: 44,
    titolo: "Blackout",
    autore: "Simon Scarrow",
    categoria: "Gialli",
    copertina: "/Gialli 2/Blackout.png", 
  },



 {
    id: 45,
    titolo: "Cattivi amici",
    autore: "Gilly Macmillan",
    categoria: "Gialli",
    copertina: "/Gialli 2/Cattivi amici.png",
  },


 {
    id: 46,
    titolo: "Cospirazione Gonzaga",
    autore: "GL Barone",
    categoria: "Gialli",
    copertina: "/Gialli 2/GL Barone.png",
  },



 {
    id: 47,
    titolo: "Il manoscritto perduto della massoneria",
    autore: "Jeroen Windmeijer",
    categoria: "Gialli",
    copertina: "/Gialli 2/Il manoscritto perduto della massoneria.png",
  },


 {
    id: 48,
    titolo: "Adriano VII",
    autore: "Frederick Rolfe",
    categoria: "Letteratura",
    copertina: "/Letteratura/Adriano VII.png",
  },


 {
    id: 49,
    titolo: "Anestesia",
    autore: "Fumetti Brutti",
    categoria: "Letteratura",
    copertina: "/Letteratura/Anestesia.png",
  },


 {
    id: 50,
    titolo: "Cuero tango y pasion",
    autore: "Mchele Andonaia",
    categoria: "Letteratura",
    copertina: "/Letteratura/Cuero tango y pasion.png", 
  },


 {
    id: 51,
    titolo: "E tutto una bugia",
    autore: "Giovanni Paolo De Matteis",
    categoria: "Letteratura",
    copertina: "/Letteratura/E tutto una bugia.png",
  },


 {
    id: 52,
    titolo: "Gabonzo",
    autore: "Dottor Pira",
    categoria: "Letteratura",
    copertina: "/Letteratura/Gabonzo.png",
  },


 {
    id: 53,
    titolo: "Il Ladro di quaderni",
    autore: "Gianni Solla",
    categoria: "Letteratura",
    copertina: "/Letteratura/Il Ladro di quaderni.png",
  },



 {
    id: 54,
    titolo: "Il tamburo di latta",
    autore: "Gunter Grass",
    categoria: "Letteratura",
    copertina: "/Letteratura/Il tamburo di latta.png",
  },

 {
    id: 55,
    titolo: "Il treno dei bambini",
    autore: "Viola Ardone",
    categoria: "Letteratura",
    copertina: "/Letteratura/Il treno dei bambini.png",
  },



 {
    id: 56,
    titolo: "La farsa gattopardesca degli scatoloni",
    autore: " Ignazio Scongnamiglio",
    categoria: "Letteratura",
    copertina: "/Letteratura/La farsa gattopardesca degli scatoloni.png",
  },



 {
    id: 47,
    titolo: "La fattoria dell'animale",
    autore: "Antonucci & Fabri",
    categoria: "Letteratura",
    copertina: "/Letteratura/La fattoria dell'animale.png",
  },


 {
    id: 58,
    titolo: "La quarta guerra mondiale",
    autore: "Taddei Spugna",
    categoria: "Letteratura",
    copertina: "/Letteratura/La quarta guerra mondiale.png",
  },



 {
    id: 59,
    titolo: "Le nostre imperfezioni",
    autore: "Luca Trapanese",
    categoria: "Letteratura",
    copertina: "/Letteratura/Le nostre imperfezioni.png",
  },



 {
    id: 60,
    titolo: "L'ora X",
    autore: "Erri De Luca Paolo Castaldi Cosimo Damiano Damato",
    categoria: "Letteratura",
    copertina: "/Letteratura/L'ora X.png",
  },


 {
    id: 61,
    titolo: "Quaderno del palazzo reale",
    autore: "Mondi Lontani",
    categoria: "Letteratura",
    copertina: "/Letteratura/Quaderno del palazzo reale.png",
  },




 {
    id: 62,
    titolo: "Tante storie per giocare",
    autore: "Gianni Rodari",
    categoria: "Letteratura",
    copertina: "/Letteratura/Tante storie per giocare.png",
  },


 {
    id: 63,
    titolo: "Abbassa il calcio viva il pallone",
    autore: "Tommaso Mandato",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Abbassa il calcio viva il pallone.png",
  },



 {
    id: 64,
    titolo: "Alba",
    autore: "Antonella Alari Espèosito",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Alba.png",
  },


 {
    id: 65,
    titolo: "Cime tempestose",
    autore: "Emily Bronte",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Cime tempestose.png",
  },



 {
    id: 66,
    titolo: "I dolori del giovane Werther",
    autore: "J.W. Goethe",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/I dolori del giovane Werther.png",
  },



 {
    id: 67,
    titolo: "I pesci non chiudono gli occhi",
    autore: "Erri De Luca",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/I pesci non chiudono gli occhi.png", 
  },


 {
    id: 68,
    titolo: "Il maestro e margherita",
    autore: "Michail Bulgakov",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il maestro e margherita.png", 
  },



 {
    id: 69,
    titolo: "Il passaporto strappato",
    autore: "Gerardina Russo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il passaporto strappato.png",
  },



 {
    id: 70,
    titolo: "Il rancore di Yukiko",
    autore: "Mario Casillo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il rancore di Yukiko.png",
  },


 {
    id: 71,
    titolo: "Marcovaldo",
    autore: "Italo Calvino",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Marcovaldo.png", 
  },



 {
    id: 72,
    titolo: "Noche porteria",
    autore: "Bruno Carapella",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Noche porteria.png",
  },



 {
    id: 73,
    titolo: "Non avevo capito ninete",
    autore: "Diego De Silva",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Non avevo capito ninete.png",
  },



 {
    id: 74,
    titolo: "Oliver Twist.",
    autore: "Charles Dickens",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Oliver Twist.png",
  },

 {
    id: 75,
    titolo: "Orgoglio e pregiudizzo",
    autore: "Jane Austen",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Orgoglio e pregiudizzo.png",
  },


 {
    id: 76,
    titolo: "Per come ti guardo ti ho già detto troppo.",
    autore: "Francesco Piscitelli",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Per come ti guardo ti ho già detto troppo.png",
  },


 {
    id: 77,
    titolo: "Scusa ma tifo Napoli",
    autore: "Gaetano Quagliarrrriello",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Scusa ma tifo Napoli.png",
  },



 {
    id: 78,
    titolo: "Storie di calcio femminile",
    autore: "Domenico La Marca | Teresa Maddalo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Storie di calcio femminile.png",
  },





 {
    id: 79,
    titolo: "Ti dimentico ma non ti cancello",
    autore: "Francesco Piscitelli",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Ti dimentico ma non ti cancello.png",
  },



{
    id: 80,
    titolo: "Ti dimentico ma non ti cancello",
    autore: "Francesco Piscitelli",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Ti dimentico ma non ti cancello.png",
  },




{
    id: 81,
    titolo: "I promessi sposi",
    autore: "Alessandro Manzoni",
    categoria: "Classici",
    copertina: "/Storia/I promessi sposi.png",
  },


{
    id: 82,
    titolo: "Il piacere",
    autore: "Gabbriele D'Annunzio",
    categoria: "Classici",
    copertina: "/Storia/Il piacere.png",
  },


{
    id: 83,
    titolo: "Il vecchio e il mare",
    autore: "Ernest Hemingway",
    categoria: "Classici",
    copertina: "/Storia/Il vecchio e il mare.png", 
  },



{
    id: 84,
    titolo: "Iliade",
    autore: "Omero",
    categoria: "Classici",
    copertina: "/Storia/Iliade.png", 
  },



{
    id: 85,
    titolo: "La divina commedia",
    autore: "Dante Alighieri",
    categoria: "Classici",
    copertina: "/Storia/La divina commedia.png",
  },




{
    id: 86,
    titolo: "L'amore ai tempi del colera",
    autore: "Gabriel Garcia Marquez",
    categoria: "Classici",
    copertina: "/Storia/L'amore ai tempi del colera.png",
  },




{
    id: 87,
    titolo: "L'aqua di sole",
    autore: "Bianca Rita Cataldi",
    categoria: "Classici",
    copertina: "/Storia/L'aqua di sole.png",
  },




{
    id: 88,
    titolo: "L'idiota",
    autore: "Fedor Dostoevskij",
    categoria: "Classici",
    copertina: "/Storia/L'idiota.png",
  },



{
    id: 89,
    titolo: "Odissea",
    autore: "Omero",
    categoria: "Classici",
    copertina: "/Storia/Odissea.png",
  },



{
    id: 90,
    titolo: "Se questo e un uomo",
    autore: "Primo Levi",
    categoria: "Classici",
    copertina: "/Storia/Se questo e un uomo.png",
  },



{
    id: 91,
    titolo: "Circe",
    autore: "Madeline Miller",
    categoria: "Classici",
    copertina: "/Storia 2/Circe.png",
  },





{
    id: 92,
    titolo: "Delitto e Castigo",
    autore: "Fedor Dostoevskiy",
    categoria: "Classici",
    copertina: "/Storia 2/Delitto e Castigo.png",
  },





{
    id: 93,
    titolo: "Diario",
    autore: "Anna Frank",
    categoria: "Classici",
    copertina: "/Storia 2/Diario.png",
  },






{
    id: 94,
    titolo: "Favole",
    autore: "Esopo",
    categoria: "Classici",
    copertina: "/Storia 2/Favole.png",
  },


{
    id: 95,
    titolo: "I firori del male",
    autore: "Charles Baudelaire",
    categoria: "Classici",
    copertina: "/Storia 2/I firori del male.png",
  },



{
    id: 96,
    titolo: "Il giro del mondo in 80 giorni",
    autore: "Jules Verne",
    categoria: "Classici",
    copertina: "/Storia 2/Il giro del mondo in 80 giorni.png",
  },




{
    id: 97,
    titolo: "Jane Eyre",
    autore: "Charlotte Bronte",
    categoria: "Classici",
    copertina: "/Storia 2/Jane Eyre.png",
  },



{
    id: 98,
    titolo: "La canzone di Achille",
    autore: "Madeline Miller",
    categoria: "Classici",
    copertina: "/Storia 2/La canzone di Achille.png",
  },



{
    id: 99,
    titolo: "La scandalosa Margot",
    autore: "Antonio Cirillo",
    categoria: "Classici",
    copertina: "/Storia 2/La scandalosa Margot.png",
  },





{
    id: 100,
    titolo: "Lo sperdimento e altro",
    autore: "Luigi Fontanella",
    categoria: "Classici",
    copertina: "/Storia 2/Lo sperdimento e altro.png",
  },





{
    id: 101,
    titolo: "Ossi di seppia",
    autore: "Eugenio Montale",
    categoria: "Classici",
    copertina: "/Storia 2/Ossi di seppia.png",
  },





{
    id: 102,
    titolo: "Poesia al senato",
    autore: "Strade Di Poesia",
    categoria: "Classici",
    copertina: "/Storia 2/Poesia al senato.png",
  },


{
    id: 103,
    titolo: "Regina di fiori",
    autore: "Mario Casillo",
    categoria: "Classici",
    copertina: "/Storia 2/Regina di fiori.png",
  },



{
    id: 104,
    titolo: "Si e fatto preghiera",
    autore: "Rita Pacilio",
    categoria: "Classici",
    copertina: "/Storia 2/Si e fatto preghiera.png",
  },



{
    id: 79,
    titolo: "Tuono.",
    autore: "Gaetanina Longobardi",
    categoria: "Classici",
    copertina: "/Storia 2/Tuono.png",
  },


{
    id: 80,
    titolo: "I Segreti delle spose indiane",
    autore: "Monica Pradhan",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/I Segreti delle spose indiane.png",
  },

{
    id: 81,
    titolo: "Il Dubbio",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il Dubbio.png",
  },

{
    id: 82,
    titolo: "La Famiglia Moskat",
    autore: "Isaac B. Singer",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/La Famiglia Moskat.png",
  },


{
    id: 83,
    titolo: "Sembra Ieri",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Sembra Ieri.png",
  },


{
    id: 84,
    titolo: "Appello",
    autore: "John Grisham",
    categoria: "Classici",
    copertina: "/Storia 2/Appello.png",
  },
{
    id: 85,
    titolo: "Elena Elena Amore Mio",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Elena Elena Amore Mio.png",
  },
{
    id: 86,
    titolo: "Iliade Odissea",
    autore: "Omero",
    categoria: "Classici",
    copertina: "/Storia 2/Iliade Odissea.png",
  },



{
    id: 87,
    titolo: "Storia Della Filosofia Graca",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Storia Della Filosofia Graca.png",
  },


{
    id: 88,
    titolo: "Hitler é  Buono E Vuol Bene All'italia",
    autore: "Bruno Rossi e Paola Pastacaldi",
    categoria: "Classici",
    copertina: "/Storia 2/Hitler é  Buono E Vuol Bene All'italia.png",
  },



{
    id: 89,
    titolo: "I Borgia",
    autore: "Roberto Gervaso",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/I Borgia.png",
  },



{
    id: 90,
    titolo: "Zio Cardellino",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Zio Cardellino.png",
  },

{
    id: 91,
    titolo: "Rai La Grande Guerra",
    autore: "Bruno Vespa",
    categoria: "Classici",
    copertina: "/Storia 2/Rai La Grande Guerra.png",
  },



{
    id: 92,
    titolo: "Il Tempo E La Felicità",
    autore: "Luciano De Crescenzo",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il Tempo E La Felicità.png",
  },

{
    id: 93,
    titolo: "Insciaqqua.",
    autore: "Giorgio Forattini",
    categoria: "Romnanzi",
    copertina: "/Romanzi 2/Insciaqqua.png",
  },



{
    id: 94,
    titolo: "Il Broker",
    autore: "John Grisham",
    categoria: "Gialli",
    copertina: "/Gialli 2/Il Broker.png",
  },



{
    id: 95,
    titolo: "Peste e Corna",
    autore: "Roberto Gervaso",
    categoria: "Classici",
    copertina: "/Storia 2/Peste e Corna.png",
  },



{
    id: 96,
    titolo: "Il Sgnor Fiat",
    autore: "Enzo Biagi",
    categoria: "Classici",
    copertina: "/Storia 2/Il Sgnor Fiat.png",
  },



{
    id: 97,
    titolo: "Mi scaglio la prima pietra",
    autore: "Nantas Salvalaggio",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Mi scaglio la prima pietra.png",
  },


{
    id: 98,
    titolo: "La verità sugli scandali finanziari",
    autore: "Vaticano",
    categoria: "Altro",
    copertina: "/Altro/La verità sugli scandali finanziari.png",
  },





{
    id: 99,
    titolo: "Introduzione alla sociaologia generale",
    autore: "Guy Rocher",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Introduzione alla sociaologia generale.png",
  },



{
    id: 100,
    titolo: "Scusatemi ho il patè d'animo",
    autore: "Guido Quaranta",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Scusatemi ho il patè d'animo.png",
  },

{
    id: 101,
    titolo: "Fiaba perversa",
    autore: "Massimo Griffo",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Fiaba perversa.png",
  },

{
    id: 102,
    titolo: "Independence day",
    autore: "Dean Dervlin",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Independence day.png",
  },

{
    id: 103,
    titolo: "Paura dei cinquanta",
    autore: "Erica Jong",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Paura dei cinquanta.png",
  },

{
    id: 104,
    titolo: "Caccia all'uomo",
    autore: "Peter Maas",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Caccia all'uomo.png",
  },


{
    id: 105,
    titolo: "A che punto è la notte",
    autore: "Adalberto Baldoni",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/A che punto è la notte.png",
  },


{
    id: 106,
    titolo: "Il sangue dei vinti",
    autore: "Giampaolo Pansa",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il sangue dei vinti.png",
  },


{
    id: 107,
    titolo: "Delitti senza castigo",
    autore: "Nantas Salvalaggio",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Delitti senza castigo.png",
  },

{
    id: 108,
    titolo: "Ombre in paradiso",
    autore: "Erich Maria Remarque",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Ombre in paradiso.png",
  },

{
    id: 109,
    titolo: "Il silenzio degli innocenti",
    autore: "Thomas Harris",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il silenzio degli innocenti.png",
  },


{
    id: 110,
    titolo: "Benito Contro Mussolini",
    autore: "Luca Goldoni",
    categoria: "Classici",
    copertina: "/Storia 2/Benito Contro Mussolini.png",
  },


{
    id: 111,
    titolo: "Onassis",
    autore: "Peter Evans",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Onassis.png",
  },


{
    id: 112,
    titolo: "Il Discepolo",
    autore: "Elizabeth Kostova",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Il Discepolo.png",
  },



{
    id: 113,
    titolo: "La Donna Delle Meraviglie",
    autore: "Alberto Bevilacqua",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/La Donna Delle Meraviglie.png",
  },


{
    id: 114,
    titolo: "La Fiera delle castronerie",
    autore: "Jean Charles",
    categoria: "Altro",
    copertina: "/Altro/La Fiera delle castronerie.png",
  },


{
    id: 115,
    titolo: "Dietro le quinte",
    autore: "Geronimo",
    categoria: "Classici",
    copertina: "/Storia 2/Dietro le quinte.png",
  },


{
    id: 116,
    titolo: "La mosca al naso",
    autore: "Roberto Gervaso",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/La mosca al naso.png",
  },



{
    id: 117,
    titolo: "Senza dire arrivederci",
    autore: "Enzo Biagi",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Senza dire arrivederci.png",
  },



{
    id: 118,
    titolo: "Questi anni nella fiat",
    autore: "Cesare Romiti",
    categoria: "Classici",
    copertina: "/Storia 2/Questi anni nella fiat.png",
  },

{
    id: 119,
    titolo: "Il socio",
    autore: "John Grisham",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il socio.png",
  },

{
    id: 120,
    titolo: "La grande bugia",
    autore: "Giampaolo Pansa",
    categoria: "Classici",
    copertina: "/Storia 2/La grande bugia.png",
  },

{
    id: 121,
    titolo: "Un piano semplice",
    autore: "Scott Smith",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Un piano semplice.png",
  },


{
    id: 122,
    titolo: "Caso di onosessualità in una donna",
    autore: "Freud",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/Caso di onosessualità in una donna.png",
  },

{
    id: 123,
    titolo: "Introduzione alla psicologia sociale",
    autore: "Eraldo De Grada",
    categoria: "Altro",
    copertina: "/Altro/Introduzione alla psicologia sociale.png",
  },


{
    id: 124,
    titolo: "Diario 1939-43",
    autore: "Galeazzo Ciano",
    categoria: "Classici",
    copertina: "/Storia 2/Diario 1939-43.png",
  },



{
    id: 125,
    titolo: "I gruppi sociali elementari",
    autore: "Michhael S. Olmsted",
    categoria: "Altro",
    copertina: "/Altro/I gruppi sociali elementari.png",
  },

{
    id: 126,
    titolo: "Lettere a Milano 1939-1945",
    autore: "Amendola",
    categoria: "Classici",
    copertina: "/Storia 2/Lettere a Milano 1939-1945.png",
  },

{
    id: 127,
    titolo: "Scusate dimenticavo",
    autore: "Enzo Biagi",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Scusate dimenticavo.png",
  },

{
    id: 128,
    titolo: "Io e Saddam",
    autore: "Peter Arnett",
    categoria: "Gialli",
    copertina: "/Gialli 2/Io e Saddam.png",
  },


{
    id: 129,
    titolo: "Caro presidente",
    autore: "Antonio Ghirelli",
    categoria: "Classici",
    copertina: "/Storia 2/Caro presidente.png",
  },



{
    id: 130,
    titolo: "La passione di Joe Crown",
    autore: "Harold Robbins",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/La passione di Joe Crown.png",
  },


{
    id: 131,
    titolo: "La lunga marcia dei Cheyenne verso l'esilio",
    autore: "Gambe di legno",
    categoria: "Classici",
    copertina: "/Storia 2/La lunga marcia dei Cheyenne verso l'esilio.png",
  },

{
    id: 132,
    titolo: "L'amante di Pilato",
    autore: "Gisbert Haefs",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/L'amante di Pilato.png",
  },



{
    id: 133,
    titolo: "Fatherland",
    autore: "Robert Harris",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Fatherland.png",
  },

{
    id: 134,
    titolo: "Addio Volodia",
    autore: "Simone Signoret",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Addio Volodia.png",
  },



{
    id: 135,
    titolo: "Io uccido",
    autore: "Giorgio Faletti",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Io uccido.png",
  },




{
    id: 136,
    titolo: "La crisi della sociologia",
    autore: "Alvin W. Gouldner",
    categoria: "Letteratura",
    copertina: "/Letteratura 2/La crisi della sociologia.png",
  },




{
    id: 137,
    titolo: "Il diziionario della medicina",
    autore: "Fratelli Fabbri Editori",
    categoria: "Altro",
    copertina: "/Altro/Il diziionario della medicina.png",
  },

{
    id: 138,
    titolo: "Il trono vuoto",
    autore: "Roberto Andò",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Il trono vuoto.png",
  },


{
    id: 139,
    titolo: "Aida",
    autore: "Giuseppe Verdi",
    categoria: "Classici",
    copertina: "/Storia 2/Aida.png",
  },


{
    id: 140,
    titolo: "Mille camere",
    autore: "Enzo Biagi",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Mille camere.png",
  },


{
    id: 141,
    titolo: "Paura di volare",
    autore: "Erica Jong",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Paura di volare.png",
  },


{
    id: 141,
    titolo: "L'ultimo Catone",
    autore: "Matilde Asensi",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/L'ultimo Catone.png",
  },


{
    id: 142,
    titolo: "Una lunga marcia",
    autore: "Rafael Chirbes",
    categoria: "Romanzi",
    copertina: "/Romanzi 2/Una lunga marcia.png",
  },

{
    id: 143,
    titolo: "Napoleone 1 La voce del destino",
    autore: "Max Gallo",
    categoria: "Storia",
    copertina:  "/Classici/Napoleone 1 La voce del destino.png",
  },


{
    id: 144,
    titolo: "Napoleone 2 I Cieli dell'impero.",
    autore: "Max Gallo",
    categoria: "Storia",
    copertina:  "/Classici/Napoleone 2 I Cieli dell'impero.png",
  },



{
    id: 145,
    titolo: "Il Congresso di vienna",
    autore: "Guglielmo Ferrero",
    categoria: "Storia",
    copertina:  "/Classici/Il Congresso di vienna.png", 
  },



{
    id: 146,
    titolo: "Alessandro 1 Lo zar della santa alleanza",
    autore: "Henri Troyat",
    categoria: "Storia",
    copertina:  "/Classici/Alessandro 1 Lo zar della santa alleanza.png", 
  },



{
    id: 147,
    titolo: "Metternich",
    autore: "Franz Herre",
    categoria: "Storia",
    copertina:  "/Classici/Metternich.png", 
  },



{
    id: 148,
    titolo: "Il Risorgimento italiano",
    autore: "Denis Mack Smith",
    categoria: "Storia",
    copertina:  "/Classici/Il Risorgimento italiano.png", 
  },


{
    id: 150,
    titolo: "Balaclava La Carica dei 600",
    autore: "Cecil Woodham-Smith",
    categoria: "Storia",
    copertina:  "/Classici/Balaclava La Carica dei 600.png", 
  },



{
    id: 151,
    titolo: "Mazzini L'Uomo ,Il Pensatore, Il Rivoluzionario",
    autore: "Denis Mack Smith",
    categoria: "Storia",
    copertina:  "/Classici/Mazzini L'Uomo ,Il Pensatore, Il Rivoluzionario.png", 
  },



{
    id: 152,
    titolo: "Risorgimento e Capitaliasmo",
    autore: "Rosario Romeo",
    categoria: "Storia",
    copertina:  "/Classici/Risorgimento e Capitaliasmo.png", 
  },



{
    id: 153,
    titolo: "Garibaldi",
    autore: "Denis Mack Smith",
    categoria: "Storia",
    copertina:  "/Classici/Garibaldi.png", 
  },


{
    id: 154,
    titolo: "Italiane Il Lato Segreto Del Risorgimento.",
    autore: "Antonio Spinosa",
    categoria: "Storia",
    copertina:  "/Classici/Italiane Il Lato Segreto Del Risorgimento.png",
  },



{
    id: 155,
    titolo: "Il Re Bomba",
    autore: "Giuseppe Campolieti",
    categoria: "Storia",
    copertina:  "/Classici/Il Re Bomba.png",
  },



{
    id: 156,
    titolo: "Vittorio Emanuele 2",
    autore: "Paolo Pinto",
    categoria: "Storia",
    copertina:  "/Classici/Vittorio Emanuele 2.png",
  },



{
    id: 157,
    titolo: "Francesco II di Borbone",
    autore: "Pier Giusto Jaeger",
    categoria: "Storia",
    copertina:  "/Classici/Francesco II di Borbone.png",
  },



{
    id: 158,
    titolo: "Storia Militare Del Risorgimento 1",
    autore: "Piero Pieri",
    categoria: "Storia",
    copertina:  "/Classici/Storia Militare Del Risorgimento 1.png",
  },


{
    id: 159,
    titolo: "Storia Militare Del Risorgimento 2",
    autore: "Piero Pieri",
    categoria: "Storia",
    copertina:  "/Classici/Storia Militare Del Risorgimento 2.png",
  },



{
    id: 160,
    titolo: "Gli Uomini Che Fecero L'italia",
    autore: "Giovanni Spadolini",
    categoria: "Storia",
    copertina:  "/Classici/Gli Uomini Che Fecero L'italia.png",
  },


{
    id: 161,
    titolo: "Pio IX",
    autore: "Andrea Tornielli",
    categoria: "Storia",
    copertina:  "/Classici/Pio IX.png",
  },



{
    id: 162,
    titolo: "Cavour Il Grande Tessitore Dell'Unità D'Italia",
    autore: "Denis Mack Smith",
    categoria: "Storia",
    copertina:  "/Classici/Cavour Il Grande Tessitore Dell'Unità D'Italia.png",
  },


{
    id: 163,
    titolo: "La Guerra Civile Americana",
    autore: "Reid Mitchell",
    categoria: "Storia",
    copertina:  "/Classici/La Guerra Civile Americana.png",
  },



{
    id: 164,
    titolo: "Lungo Le Rive Del Colorado",
    autore: "Dee Brown",
    categoria: "Storia",
    copertina:  "/Classici/Lungo Le Rive Del Colorado.png",
  },


{
    id: 165,
    titolo: "Storia DEgli Indiani D'America",
    autore: "Philippe Jacquin",
    categoria: "Storia",
    copertina:  "/Classici/Storia DEgli Indiani D'America.png",
  },


{
    id: 166,
    titolo: "La piccola Regina",
    autore: "Carolly Erickson",
    categoria: "Storia",
    copertina:  "/Classici/La piccola Regina.png",
  },



{
    id: 167,
    titolo: "Marx",
    autore: "Francis Wheen",
    categoria: "Storia",
    copertina:  "/Classici/Marx.png",
  },


{
    id: 168,
    titolo: "Ludwig",
    autore: "Greg King",
    categoria: "Storia",
    copertina:  "/Classici/Ludwig.png",
  },



{
    id: 169,
    titolo: "Storia Economica D'Italia",
    autore: "Mario Romani",
    categoria: "Storia",
    copertina:  "/Classici/Storia Economica D'Italia.png",
  },



{
    id: 170,
    titolo: "Gli Emigrati Vittoriosi",
    autore: "Andrew F. Rolle",
    categoria: "Storia",
    copertina:  "/Classici/Gli Emigrati Vittoriosi.png",
  },



{
    id: 171,
    titolo: "Lindustrializzazione in europa nellì 800",
    autore: "Tom Kemp",
    categoria: "Storia",
    copertina:  "/Classici/Lindustrializzazione in europa nellì 800.png",
  },




{
    id: 172,
    titolo: "Francesco Giuseppe Il Lungo Crepuscolo degli Assurgo",
    autore: "Alan Palmer",
    categoria: "Storia",
    copertina:  "/Classici/Francesco Giuseppe Il Lungo Crepuscolo degli Assurgo.png",
  },



{
    id: 173,
    titolo: "Requiem per un impero defunto",
    autore: "Francois Feljtò",
    categoria: "Storia",
    copertina:  "/Classici/Requiem per un impero defunto.png",
  },


{
    id: 174,
    titolo: "Rasputin",
    autore: "Edward Radzinsku",
    categoria: "Storia",
    copertina:  "/Classici/Rasputin.png",
  },



{
    id: 175,
    titolo: "La spartizione DEll'africa",
    autore: "Henri Wesseling",
    categoria: "Storia",
    copertina:  "/Classici/La spartizione DEll'africa.png",
  },

{
    id: 176,
    titolo: "Crispi",
    autore: "Sergio Romano",
    categoria: "Storia",
    copertina:  "/Classici/Crispi.png",
  },


{
    id: 177,
    titolo: "L'anarchico che venne Dalla'Amarica",
    autore: "Arrigo Petacco",
    categoria: "Storia",
    copertina:  "/Classici/L'anarchico che venne Dalla'Amarica.png",
  },



{
    id: 178,
    titolo: "La regina Margherita",
    autore: "Carlo Casalegno",
    categoria: "Storia",
    copertina:  "/Classici/La regina Margherita.png",
  },

{
    id: 179,
    titolo: "Storia D'Italia Moderna 1815-1898",
    autore: "Gioacchino Volpe",
    categoria: "Storia",
    copertina:  "/Classici/Storia D'Italia Moderna 1815-1898.png",
  },


{
    id: 180,
    titolo: "Storia D'italia Moderna 1898-1910",
    autore: "Gioacchino Volpe",
    categoria: "Storia",
    copertina:  "/Classici/Storia D'italia Moderna 1898-1910.png",
  },


{
    id: 181,
    titolo: "Lorenzo il magnifico  1",
    autore: "Ivan Cloulas",
    categoria: "Storia",
    copertina:  "/Classici/Lorenzo il magnifico  1.png",
  },


{
    id: 182,
    titolo: "Lorenzo il magnifico  2",
    autore: "Ivan Cloulas",
    categoria: "Storia",
    copertina:  "/Classici/Lorenzo il magnifico  2.png",
  },



{
    id: 183,
    titolo: "Le repubbliche marinare",
    autore: "Gino Benvenuti",
    categoria: "Storia",
    copertina:  "/Classici/Le repubbliche marinare.png",
  },



{
    id: 184,
    titolo: "Cristoforo Colombo",
    autore: "Samuel Eliot Morison",
    categoria: "Storia",
    copertina:  "/Classici/Cristoforo Colombo.png",
  },


{
    id: 185,
    titolo: "Tex",
    autore: "Gianluigi Bonelli - Aurelio Galleppini",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Tex.png",
  },



{
    id: 186,
    titolo: "Paperino",
    autore: "Disney",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Paperino.png",
  },




{
    id: 187,
    titolo: "Peanuts",
    autore: "Charles M. Schlz",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Peanuts.png",
  },



{
    id: 188,
    titolo: "Altan",
    autore: "L'arte Di Altan",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Altan.png",
  },



{
    id: 189,
    titolo: "KenParker",
    autore: "Giancarlo Berrardi - Ivo Milazzo",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/KenParker.png",
  },



{
    id: 190,
    titolo: "Mandrake e L'uomo Maschrerato",
    autore: "Lee . Phil Davis . Ray Moore",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Mandrake e L'uomo Maschrerato.png",
  },


{
    id: 191,
    titolo: "Martin Mystere",
    autore: "Alfredo Castelli",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Martin Mystere.png",
  },


{
    id: 192,
    titolo: "Rat-Man",
    autore: "Leo Ortolani",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Rat-Man.png",
  },




{
    id: 193,
    titolo: "Max Fridman",
    autore: "Vittorio Giardino",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Max Fridman.png",
  },


{
    id: 194,
    titolo: "Sturmtruppen",
    autore: "Bonvi",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Sturmtruppen.png",
  },


{
    id: 195,
    titolo: "Nathan Never",
    autore: "Michele Medda . Antonio Serra . Bepi Vigna",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Nathan Never.png",
  },



{
    id: 196,
    titolo: "Tintin",
    autore: "Hergé",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Tintin.png",
  },


{
    id: 197,
    titolo: "Zagor",
    autore: "Guido Nolitta - Gallieno Ferri",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Zagor.png",
  },


{
    id: 198,
    titolo: "Lucki Luke",
    autore: "Goscinny - Morris",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Lucki Luke.png",
  },

{
    id: 199,
    titolo: "Hulk",
    autore: "Stan Lee - Jack Kirby",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Hulk.png",
  },


{
    id: 200,
    titolo: "Mafalda",
    autore: "Quino",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Mafalda.png",
  },




{
    id: 201,
    titolo: "Eva Kant",
    autore: "Angela e Luciana Giussiani",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Eva Kant.png",
  },




{
    id: 202,
    titolo: "Mister no",
    autore: "Guido Nolitta",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Mister no.png",
  },


{
    id: 203,
    titolo: "Jeff Hawke",
    autore: "Sydney Jordan",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Jeff Hawke.png",
  },



{
    id: 204,
    titolo: "Jiro",
    autore: "L'arte di Jiro Taniguchi",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Jiro.png",
  },


{
    id: 205,
    titolo: "Snoopy",
    autore: "Charles M. Schulz",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Snoopy.png",
  },



{
    id: 206,
    titolo: "Dilbert",
    autore: "Scott Adams",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Dilbert.png",
  },


{
    id: 207,
    titolo: "Dago",
    autore: "Robin Wood - Alberto Salinas",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Dago.png",
  },


{
    id: 208,
    titolo: "Pogo",
    autore: "Walt Kelly",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Pogo.png",
  },



{
    id: 209,
    titolo: "Flash Gordon & Top Kirby",
    autore: "Alex Raymond",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Flash Gordon & Top Kirby.png",
  },


{
    id: 210,
    titolo: "Maus",
    autore: "Art Spiegelman",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Maus.png",
  },




{
    id: 211,
    titolo: "Blek",
    autore: "Essegesse",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Blek.png",
  },


{
    id: 212,
    titolo: "Braccio Di Ferro",
    autore: "Elzie Crisler segar",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Braccio Di Ferro.png",
  },


{
    id: 213,
    titolo: "Dick Tracy",
    autore: "Chester Gould",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Dick Tracy.png",
  },


{
    id: 214,
    titolo: "Andy Capp",
    autore: "Reg Smythe",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Andy Capp.png",
  },



{
    id: 215,
    titolo: "Conan",
    autore: "Robert E. Howard",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Conan.png",
  },

{
    id: 216,
    titolo: "Buzzelli",
    autore: "L'arte di Guido Buzzelli",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Buzzelli.png",
  },



{
    id: 217,
    titolo: "Alack Sinner",
    autore: "José Munoz - Carlos Sampayo",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Alack Sinner.png",
  },



{
    id: 218,
    titolo: "Bobo",
    autore: "Sergio Staino",
    categoria: "Libri per ragazzi",
    copertina:  "/Libri per ragazzi/Bobo.png",
  },



{
    id: 219,
    titolo: "Eneide volume2",
    autore: "Virgilio",
    categoria: "Classici",
    copertina:  "/Storia/Eneide volume2 .png",
  },


{
    id: 220,
    titolo: "I Menecmi",
    autore: "Plauto",
    categoria: "Classici",
    copertina:  "/Storia/I Menecmi.png",
  },


{
    id: 221,
    titolo: "Storie Volume IV",
    autore: "Erotodo",
    categoria: "Classici",
    copertina:  "/Storia/Storie Volume IV.png",
  },



{
    id: 222,
    titolo: "La guerra civile",
    autore: "Cesare",
    categoria: "Classici",
    copertina:  "/Storia/La guerra civile.png",
  },


{
    id: 223,
    titolo: "Favole",
    autore: "Esopo",
    categoria: "Classici",
    copertina:  "/Storia/Favole.png",
  },


{
    id: 224,
    titolo: "Elegie",
    autore: "Tibullo",
    categoria: "Classici",
    copertina:  "/Storia/Elegie.png",
  },



{
    id: 225,
    titolo: "Le Metamorfosi o L'asino d'or volumeII",
    autore: "Apuleio",
    categoria: "Classici",
    copertina:  "/Storia/Le Metamorfosi o L'asino d'or volumeII.png",
  },


{
    id: 226,
    titolo: "Baccanti",
    autore: "Euiripide",
    categoria: "Classici",
    copertina:  "/Storia/Baccanti.png",
  },


{
    id: 227,
    titolo: "La repubblica volume II",
    autore: "Platone",
    categoria: "Classici",
    copertina:  "/Storia/La repubblica volume II.png",
  },


{
    id: 228,
    titolo: "Dialoghi",
    autore: "Seneca",
    categoria: "Classici",
    copertina:  "/Storia/Dialoghi.png",
  },


{
    id: 229,
    titolo: "Satire",
    autore: "Orazio",
    categoria: "Classici",
    copertina:  "/Storia/Satire.png",
  },


{
    id: 230,
    titolo: "L'arte d'amare",
    autore: "Ovidio",
    categoria: "Classici",
    copertina:  "/Storia/L'arte d'amare.png",
  },

{
    id: 231,
    titolo: "Apologia di Socreate Critone",
    autore: "Platone",
    categoria: "Classici",
    copertina:  "/Storia/Apologia di Socreate Critone.png",
  },


{
    id: 232,
    titolo: "Bucoliche",
    autore: "Virgilio",
    categoria: "Classici",
    copertina:  "/Storia/Bucoliche.png",
  },

{
    id: 232,
    titolo: "Epigrammi",
    autore: "Marziale",
    categoria: "Classici",
    copertina:  "/Storia/Epigrammi.png",
  },


{
    id: 233,
    titolo: "Vite Parallele Alessandro e Cesare",
    autore: "Plutarco",
    categoria: "Classici",
    copertina:  "/Storia/Vite Parallele Alessandro e Cesare.png",
  },


{
    id: 234,
    titolo: "Lettere 2",
    autore: "Cicerone",
    categoria: "Classici",
    copertina:  "/Storia/Lettere 2.png",
  },



{
    id: 235,
    titolo: "Poetica",
    autore: "Aristotele",
    categoria: "Classici",
    copertina:  "/Storia/Poetica.png",
  },

{
    id: 236,
    titolo: "La pentola del tesoro",
    autore: "Plauto",
    categoria: "Classici",
    copertina:  "/Storia/La pentola del tesoro.png",
  },



{
    id: 237,
    titolo: "Catilinarie",
    autore: "Cicerone",
    categoria: "Classici",
    copertina:  "/Storia/Catilinarie.png",
  },



{
    id: 238,
    titolo: "Simposio",
    autore: "Platone",
    categoria: "Classici",
    copertina:  "/Storia/Simposio.png",
  },


{
    id: 239,
    titolo: "Le opere e i giorni Lo scudo di Eracle",
    autore: "Esiodo",
    categoria: "Classici",
    copertina:  "/Storia/Le opere e i giorni Lo scudo di Eracle.png",
  },


{
    id: 240,
    titolo: "Medea",
    autore: "Euripide",
    categoria: "Classici",
    copertina:  "/Storia/Medea.png",
  },


{
    id: 241,
    titolo: "Satyricon",
    autore: "Petronio Arbitro",
    categoria: "Classici",
    copertina:  "/Storia/Satyricon.png",
  },


{
    id: 242,
    titolo: "La natura delle cose volume I",
    autore: "Lucrezio",
    categoria: "Classici",
    copertina:  "/Storia/La natura delle cose volume I.png",
  },


{
    id: 243,
    titolo: "Antigone Edipo re Edipo a Colono",
    autore: "Sofocle",
    categoria: "Classici",
    copertina:  "/Storia/Antigone Edipo re Edipo a Colono.png",
  },


{
    id: 244,
    titolo: "La natura delle cose volume II",
    autore: "Lucrezio",
    categoria: "Classici",
    copertina:  "/Storia/La natura delle cose volume II.png",
  },



{
    id: 245,
    titolo: "La Guerra di Giugurta",
    autore: "Sallustio",
    categoria: "Classici",
    copertina:  "/Storia/La Guerra di Giugurta.png",
  },


{
    id: 246,
    titolo: "Lisistrata Le donne al parlamento",
    autore: "Aristofane",
    categoria: "Classici",
    copertina:  "/Storia/Lisistrata Le donne al parlamento.png",
  },


{
    id: 247,
    titolo: "Poesie",
    autore: "Saffo",
    categoria: "Classici",
    copertina:  "/Storia/Poesie.png",
  },



{
    id: 248,
    titolo: "Dell'oratore volume I",
    autore: "Cicerone",
    categoria: "Classici",
    copertina:  "/Storia/Dell'oratore volume I.png",
  },


{
    id: 249,
    titolo: "La vita di Agricola La Germania",
    autore: "Tacito",
    categoria: "Classici",
    copertina:  "/Storia/La vita di Agricola La Germania.png",
  },


{
    id: 250,
    titolo: "La repubblica volume I",
    autore: "Platone",
    categoria: "Classici",
    copertina:  "/Storia/La repubblica volume I.png",
  },


{
    id: 251,
    titolo: "I Canti",
    autore: "Catullo",
    categoria: "Classici",
    copertina:  "/Storia/I Canti.png",
  },


{
    id: 252,
    titolo: "Orestea",
    autore: "Eschilo",
    categoria: "Classici",
    copertina:  "/Storia/Orestea.png",
  },



{
    id: 253,
    titolo: "Dialoghi La vecchiezza - L'amicizia",
    autore: "Cicerone",
    categoria: "Classici",
    copertina:  "/Storia/Dialoghi La vecchiezza - L'amicizia.png",
  },



{
    id: 254,
    titolo: "Anabasi",
    autore: "Senofonte",
    categoria: "Classici",
    copertina:  "/Storia/Anabasi.png",
  },



{
    id: 255,
    titolo: "Dell'oratore volume II",
    autore: "Cicerone",
    categoria: "Classici",
    copertina:  "/Storia/Dell'oratore volume II.png",
  },



{
    id: 257,
    titolo: "Le Metamorfosi o L'asino d'oro",
    autore: "Apuleio",
    categoria: "Classici",
    copertina:  "/Storia/Le Metamorfosi o L'asino d'oro.png",
  },


{
    id: 258,
    titolo: "Ricordi volume II",
    autore: "Marco Aurelio",
    categoria: "Classici",
    copertina:  "/Storia/Ricordi volume II.png",
  },


{
    id: 259,
    titolo: "Ricordi volume I",
    autore: "Marco Aurelio",
    categoria: "Classici",
    copertina:  "/Storia/Ricordi volume I.png",
  },





];
